export default __webpack_public_path__ + "static/katreque-923ce418b1a247d89a193082581f77c8.jpg";